// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-portfolio-portfolio-detail-CaseTabs-module__root--2oRle","override":"src-components-page-portfolio-portfolio-detail-CaseTabs-module__override--i7XoY"};